var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 67,
    viewBox: "0 0 68 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_93",
    "data-name": "Gruppe 93",
    transform: "translate(-974 -57.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(974 57.15)",
    fill: "#fff",
    stroke: "#de3c4a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 33.5,
    rx: 34,
    ry: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34,
    cy: 33.5,
    rx: 33.5,
    ry: 33,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_28",
    "data-name": "Rechteck 28",
    width: 6.911,
    height: 31.792,
    rx: 3.456,
    transform: "translate(1017.353 77.357) rotate(45)",
    fill: "#de3c4a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_29",
    "data-name": "Rechteck 29",
    width: 6.911,
    height: 31.792,
    rx: 3.456,
    transform: "translate(1022.24 99.838) rotate(135)",
    fill: "#de3c4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrong);
export default __webpack_public_path__ + "static/media/IconWrong.4f4b4386b5bf50ca1ee439de7ef582f1.svg";
export { ForwardRef as ReactComponent };